import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Student from "./Student";
import Mentor from "./Mentor";
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <Router>
        <Switch>
            <Route exact path="/student/:room_id" component={Student}/>
            <Route exact path="/mentor/:room_id" component={Mentor}/>
            <Route component={() => {
              return(
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center"
                  }}>
                  <h2>
                    404 : NOT FOUND<span aria-labelledby="frowny face" role="img">
                      ☹️
                    </span>
                  </h2>
                  <p>
                    Cookie🍪 for curiosity, but there's nothing here.
                  </p>
                </div>
              )
            }}/>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js